
import { defineComponent, Ref, ref, watch, computed } from "vue";
import type { PropType } from "vue";
import Api from "@/services/Api";
import useAlert from "../../../composables/Alert";



export default defineComponent({
  name: "ModalPlanilhaFiltro",
  components: {
    // ModalDialogo,
  },
  props: {
    arquivo: Object as PropType<any>,
    rodandoFila: Boolean,
    pegarListaDePlanilhas: Function,
    alteraRodandoFila: Function,
    fechaModal: Function,
    abreModal: Function,
    tipo: String
  },

  setup(props) {

    const { showTimeAlert } = useAlert();

    const tipo = computed(() => props.tipo);
    const modalDialogo: Ref<any> = ref()
    const loadingBaixarPlanilha = ref(false)
    const loadindRodandoFila = ref(false)
    const filePath = ref('');


    function close(){
      props.fechaModal && props.fechaModal()

    }

    async function baixaPlanilha(arquivo: any, tipo: any) {

      try{
        loadingBaixarPlanilha.value = true
        
        if(tipo == 'Upload') filePath.value = "planilhas/filtros/"
        else filePath.value = "planilhas/relatorios/"

        const response = await Api.get('baixaPlanilhaFiltros', { filePath:  filePath.value, fileName: props.arquivo.nome }, { responseType: 'blob' })

        baixaArquivo(response, arquivo.nome)

      }catch(error){
        console.log(error)
        showTimeAlert('ocorreu um erro inesperado!', "error")
      }finally{
        loadingBaixarPlanilha.value = false
      }
     
    }

    function baixaArquivo(blobParam:any, name:string) {
      const url = URL.createObjectURL(new Blob([blobParam]));
      const link = document.createElement('a');
      link.href = url;
      link.download = name
      link.click();
      URL.revokeObjectURL(url);
    }



    async function rodaPlanilha() {
        loadindRodandoFila.value = true
      try {
        // so podera processar fila se for usuario superAdmin
        const { data } = await Api.get("processaFilaPorNome", { nome: props.arquivo.nome })
  
        if(data.erro) return showTimeAlert(data.mensagem, "error")
  
        showTimeAlert(data.mensagem)
        props.pegarListaDePlanilhas && props.pegarListaDePlanilhas()

      } catch (error) { 
        console.log(error); showTimeAlert('ocorreu um erro inesperado!', "error") 

      }finally{
        loadindRodandoFila.value = false
      }

      close()
    }

    // abrindo modal com usuario
    watch(() => props.arquivo, async () => { props.abreModal }, { deep: true })

    return {
      close,
      modalDialogo,
      baixaPlanilha,
      rodaPlanilha,
      loadingBaixarPlanilha,
      loadindRodandoFila,
      tipo
    };
  },
});
